import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";

function MarketPlaceFeaturesTemplate(props: ObjectFieldTemplateProps, func: any) {
  return (
    <>
      <div className="cms-section">
        <div className="h3">{props.title}</div>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("icon", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("title", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("subtitle", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MarketPlaceFeaturesTemplate;
